// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1TZXf","col":"styles_col__1rBVv"};